/**
 * 단어의 마지막 글자 받침 유무에 따라 주격 조사 '이/가'를 반환합니다.
 * - 받침(종성)이 있으면 '이', 없으면 '가'.
 *
 * @param word 조사(주격)를 붙일 대상 단어
 * @returns '이' | '가'
 * @example
 * getJosaGa('사과') // '가'
 * getJosaGa('책')   // '이'
 */
export function getJosaGa(word: string): '이' | '가' {
  if (!word || typeof word !== 'string') return '이';
  const code = word.charCodeAt(word.length - 1);
  const hasJong = (code - 0xac00) % 28 !== 0;
  return hasJong ? '이' : '가';
}

/**
 * (Deprecated) 단어의 마지막 글자에 받침이 있는지 여부를 반환합니다.
 * - 새 코드에서는 `getJosaGa` 사용을 권장합니다.
 *
 * @deprecated 대신 `getJosaGa`를 사용하세요.
 * @param korStr 받침 유무를 확인할 단어
 * @returns 받침이 있으면 true, 없으면 false
 */
export function isEndWithConsonant(korStr: string): boolean {
  if (!korStr || typeof korStr !== 'string') return true;
  const finalChrCode = korStr.charCodeAt(korStr.length - 1);
  const finalConsonantCode = (finalChrCode - 44032) % 28; // 0 = 받침 없음
  return finalConsonantCode !== 0;
}

/**
 * 목적/방향 조사 '으로/로'를 반환합니다.
 * - 받침(종성)이 있으면 '으로', 없으면 '로'
 *
 * @param word 조사(으로/로)를 붙일 대상 단어
 * @returns '으로' | '로'
 * @example
 * getJosaEuRo('사과') // '로'
 * getJosaEuRo('책')   // '으로'
 */
export const getJosaEuRo = (word: string): '으로' | '로' => {
  if (!word || typeof word !== 'string') return '으로';
  const ch = word.charCodeAt(word.length - 1);
  const hasJong = (ch - 0xac00) % 28 !== 0;
  return hasJong ? '으로' : '로';
};
